import { render, staticRenderFns } from "./navDocument1.vue?vue&type=template&id=0b716460&scoped=true&"
import script from "./navDocument1.vue?vue&type=script&lang=js&"
export * from "./navDocument1.vue?vue&type=script&lang=js&"
import style0 from "./navDocument1.vue?vue&type=style&index=0&id=0b716460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b716460",
  null
  
)

export default component.exports